import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import timelinebg from "../IMAGES-ADHIBA/NEW-TIMELINE/timeline-bg-sample.png";
import circlebg from "../IMAGES-ADHIBA/NEW-TIMELINE/circle-shadow.png";

gsap.registerPlugin(ScrollTrigger);

const ScrollTimeline = () => {
    const containerRef = useRef(null);
    const item1Ref = useRef(null);
    const item2Ref = useRef(null);
    const item3Ref = useRef(null);
    const item4Ref = useRef(null);
    const circle1Ref = useRef(null);
    const circle2Ref = useRef(null);
    const circle3Ref = useRef(null);
    const circle4Ref = useRef(null);
    const year1Ref = useRef(null);
    const year2Ref = useRef(null);
    const year3Ref = useRef(null);
    const year4Ref = useRef(null);


    useEffect(() => {
        const items = [item1Ref, item2Ref, item3Ref, item4Ref];
        const circles = [circle1Ref, circle2Ref, circle3Ref, circle4Ref];
        const years = [year1Ref, year2Ref, year3Ref, year4Ref];

        const ctx = gsap.context(() => {
            items.forEach((itemRef, index) => {
                if (!itemRef.current) return;

                gsap.fromTo(
                    itemRef.current,
                    {
                        y: 30,
                        opacity: 0.2
                    },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 1,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: containerRef.current,
                            start: `top+=${index * 20}% top`,
                            end: `top+=${index * 20 + 30}% top`,
                            scrub: 1,
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            });

            // Circle scale animations
            circles.forEach((circleRef, index) => {
                if (!circleRef.current) return;

                gsap.fromTo(
                    circleRef.current,
                    { height: 110 },
                    {
                        height: 130,
                        duration: 1,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: containerRef.current,
                            start: `top+=${index * 20 + 15}% top`,
                            end: `top+=${index * 20 + 35}% top`,
                            scrub: 1
                        }
                    }
                );

            });

            years.forEach((yearRef, index) => {
                if (!yearRef.current) return;

                gsap.fromTo(
                    yearRef.current,
                    { fontSize: 32 },
                    {
                        fontSize: 35,
                        duration: 1,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: containerRef.current,
                            start: `top+=${index * 20}% top`,
                            end: `top+=${index * 20 + 20}% top`,
                            scrub: 1,
                        }
                    }
                );
            });
        }, containerRef);

        return () => ctx.revert();
    }, []);

    return (
        <div className='new-timeline' ref={containerRef} style={{ height: '400vh', position: 'relative' }}>
            <div style={{
                position: 'sticky',
                top: 0,
                height: '930px',
                width: '100%',
                backgroundImage: `url(${timelinebg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                overflow: 'hidden',
                objectFit: "cover",
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: '80px 20px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: '10px'
                }}>

                    {/* Timeline Item 1 */}
                    <div ref={item1Ref} style={{ width: '25%', padding: '0', marginTop: '60px', paddingLeft: "100px" }}>
                        <h2 ref={year1Ref} style={{
                            color: '#313985',
                            fontSize: '32px',
                            fontWeight: 'bold',
                            marginBottom: '16px'
                        }} className="year-heading">
                            2014
                        </h2>
                        <p style={{
                            color: '#000',
                            fontSize: '13px',
                            lineHeight: '1.6',
                            marginBottom: '15px'
                        }}>
                            He was born in 1881 (probably in the spring) in Salonica, then an Ottoman city, now in Greece. His father Ali Riza, a customs official turned
                        </p>
                        <img src={circlebg} ref={circle1Ref} className='img-fluid' style={{ height: "110px" }} />
                    </div>

                    {/* Timeline Item 2 */}
                    <div ref={item2Ref} style={{ width: '25%', padding: '0', marginTop: '280px', paddingLeft: "120px" }}>
                        <h2 ref={year2Ref} style={{
                            color: '#313985',
                            fontSize: '32px',
                            fontWeight: 'bold',
                            marginBottom: '16px'
                        }} className="year-heading">
                            2018
                        </h2>
                        <p style={{
                            color: '#000',
                            fontSize: '13px',
                            lineHeight: '1.6',
                            marginBottom: '15px'
                        }}>
                            First enrolled in a traditional religious school, he soon switched to a modern school. In 1893, he entered a military high school where his mathematics teacher gave him the second name Kemal (meaning perfection) in recognition of young Mustafa's superior achievement.
                        </p>
                        <img src={circlebg} ref={circle2Ref} className='img-fluid' style={{ height: "110px" }} />
                    </div>

                    {/* Timeline Item 3 */}
                    <div ref={item3Ref} style={{ width: '25%', padding: '0', marginTop: '70px', paddingLeft: "100px" }}>
                        <h2 ref={year3Ref} style={{
                            color: '#313985',
                            fontSize: '32px',
                            fontWeight: 'bold',
                            marginBottom: '16px'
                        }} className="year-heading">
                            2020
                        </h2>
                        <p style={{
                            color: '#000',
                            fontSize: '13px',
                            lineHeight: '1.6',
                            marginBottom: '15px'
                        }}>
                            In 1908 he helped the group of officers who toppled the Sultan. Mustafa Kemal's career flourished as he won his heroism in the far corners of the Ottoman Empire, including Albania and Tripoli. He also briefly served as a staff officer in Salonica and Istanbul and as a military attache in Sofia.
                        </p>
                        <img src={circlebg} ref={circle3Ref} className='img-fluid' style={{ height: "110px" }} />
                    </div>

                    {/* Timeline Item 4 */}
                    <div ref={item4Ref} style={{ width: '25%', padding: '0', marginTop: '500px', paddingLeft: "80px" }}>
                        <h2 ref={year4Ref} style={{
                            color: '#313985',
                            fontSize: '32px',
                            fontWeight: 'bold',
                            marginBottom: '16px'
                        }} className="year-heading">
                            2021
                        </h2>
                        <p style={{
                            color: '#000',
                            fontSize: '13px',
                            lineHeight: '1.6',
                            marginBottom: '15px'
                        }}>
                            In 1915, when Dardanelles campaign was launched, Colonel Mustafa Kemal became a national hero by winning successive victories and finally repelling the invaders.
                        </p>
                        <img src={circlebg} ref={circle4Ref} className='img-fluid' style={{ height: "110px" }} />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ScrollTimeline;